// extracted by mini-css-extract-plugin
export default {"wrapper":"yB-z","button":"zB-z","alternate":"AB-z","disabled":"BB-z","paymentWarning":"CB-z","fadeIn":"DB-z"};